import { VuexModule, Module, Mutation, getModule, Action } from 'vuex-module-decorators';
import store from '@/store/index';
import { SystemSettingsClient, SystemSettingsDto } from '@/apiclient/apiclient_generated';
import axios from 'axios';
import { WS_URL as ApiUrl } from '@/config';

@Module({ dynamic: true, namespaced: true, store, name: 'systemSettings' })
export class SystemSettingsModule extends VuexModule {
  public systemSettingsClient = new SystemSettingsClient(ApiUrl, axios);
  systemSettings: SystemSettingsDto = new SystemSettingsDto();

  @Action
  async loadData() {
    const systemSettings = await this.systemSettingsClient.getSystemSettings();
    this.setSystemSettings(systemSettings);
  }

  @Mutation
  setSystemSettings(systemSettings: SystemSettingsDto) {
    this.systemSettings = systemSettings;
  }
}

export const SystemSettingsStore = getModule(SystemSettingsModule);
